import { IoMdClose } from 'react-icons/io';
import { GoArrowLeft } from 'react-icons/go';
import { BsAndroid2, BsFillShareFill } from 'react-icons/bs';
import { FiArrowRightCircle } from 'react-icons/fi';

import {
    FaWallet,
    FaMoneyBillWave,
    FaHandHoldingUsd,
    FaExchangeAlt,
    FaHistory,
    FaChartLine,
    FaRegFileAlt,
    FaFileInvoiceDollar,
    FaBullhorn,
    FaGift,
    FaSitemap,
    FaUserFriends,
    FaBookOpen,
    FaUserCircle,
    FaPhoneAlt,
    FaUniversity,
} from 'react-icons/fa';
import { MdSupportAgent } from 'react-icons/md';
import { FaChevronRight, FaChevronLeft, FaChevronDown } from 'react-icons/fa6';
import { HiMinusSm, HiPlusSm } from 'react-icons/hi';
import { MdLockOutline } from 'react-icons/md';
import { FiEdit } from 'react-icons/fi';
import { LuCheck } from 'react-icons/lu';
import { IoMdLogOut } from 'react-icons/io';
import { FiShield } from 'react-icons/fi';
import { FiMenu } from 'react-icons/fi';
import { IoSettingsOutline } from 'react-icons/io5';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import { GoHomeFill } from 'react-icons/go';
import { CiImageOff } from 'react-icons/ci';
import { FaPlay } from 'react-icons/fa';
import { FaCaretLeft } from 'react-icons/fa6';
import { FaRegBell } from 'react-icons/fa';
import { SiEthereum } from 'react-icons/si';
import { IoWalletOutline } from 'react-icons/io5';
import { IoCopyOutline } from 'react-icons/io5';
import { FiTrash } from 'react-icons/fi';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { RxLoop } from 'react-icons/rx';
import { BsPerson } from 'react-icons/bs';
import { MdDelete } from 'react-icons/md';
import { IoIosCheckmarkCircle } from 'react-icons/io';
import { LuLoaderCircle } from "react-icons/lu";
import { FaRegStar } from "react-icons/fa6";
import { FaStar } from "react-icons/fa6";
import { FaRegHeart } from "react-icons/fa";
import { FaHeart } from "react-icons/fa";
import { AiOutlineClockCircle, AiOutlineUser } from 'react-icons/ai';
import { GiSoccerKick } from 'react-icons/gi';
import { FaDice } from 'react-icons/fa';
import { HiHome } from 'react-icons/hi2';
import { FaUserGroup } from "react-icons/fa6";
import { LuSearch } from "react-icons/lu";
import { FaMinus } from "react-icons/fa6";
import { MdLiveTv } from "react-icons/md";
import { FaRegChartBar } from "react-icons/fa";

export const Icons = {
    tv: MdLiveTv,
    chart: FaRegChartBar,
    share: BsFillShareFill,
    leftArrow: GoArrowLeft,
    android: BsAndroid2,
    circularRightArrow: FiArrowRightCircle,
    // Sidebar icons
    myWallet: FaWallet,
    wallet2: IoWalletOutline,
    deposit: FaMoneyBillWave,
    withdraw: FaHandHoldingUsd,
    myTransaction: FaExchangeAlt,
    betHistory: FaHistory,
    bettingProfitLoss: FaChartLine,
    turnoverHistory: FaRegFileAlt,
    accountStatement: FaUniversity,
    commissionReport: FaFileInvoiceDollar,
    promotions: FaBullhorn,
    bonusStatement: FaGift,
    affiliate: FaSitemap,
    referral: FaUserFriends,
    stakeSettings: IoSettingsOutline,
    gameRules: FaBookOpen,
    myProfile: FaUserCircle,
    contactSupport: MdSupportAgent,
    angularLeftArrow: FaChevronLeft,
    angularRightArrow: FaChevronRight,
    angularDownArrow: FaChevronDown,
    plus: HiPlusSm,
    minus: FaMinus,
    lock: MdLockOutline,
    edit: FiEdit,
    check: LuCheck,
    logout: IoMdLogOut,
    shield: FiShield,
    hambuger: FiMenu,
    openEye: IoMdEye,
    closeEye: IoMdEyeOff,
    // home: GoHomeFill,
    close: IoMdClose,
    imageOff: CiImageOff,
    playButton: FaPlay,
    filledLeftButton: FaCaretLeft,
    bell: FaRegBell,
    eth: SiEthereum,
    copy: IoCopyOutline,
    trash: FiTrash,
    back: IoArrowBackCircleSharp,
    swap: RxLoop,
    user: BsPerson,
    delete: MdDelete,
    circleCheck: IoIosCheckmarkCircle,
    loader: LuLoaderCircle,
    outlineStar: FaRegStar,
    fillStar: FaStar,
    outlineHeart: FaRegHeart,
    fillHeart: FaHeart,
    home: HiHome,
    dice: FaDice,
    kick: GiSoccerKick,
    clock: AiOutlineClockCircle,
    userTwo: AiOutlineUser,
    userGroup: FaUserGroup,
    search: LuSearch,
};
